import React from 'react'
import { Flex, Link, Heading, Text } from 'theme-ui'
import { nanoid } from 'nanoid'
import checkIfExternalLink from '../../../helpers/checkIfExternalLink'
import generateLink from '../../../helpers/generateLink'
import ImageSelector from '../../Images/ImageSelector'

export default function HardCodedBoxes(props) {
  const {
    options,
    variantName,
    city,
    // configData,
    // businessData,
    poweredImages,
    isMultiLocationSite,
    locationIndex,
    allGeneral
  } = props

  const { titles, subtitles, texts, dates, images, ctaLinks } = options

  const getOptionToLoopOver = () => {
    // finds the longest array out of the selected content data below and returns a object key
    const contentData = { titles, subtitles, texts, dates, images, ctaLinks }
    let longestArrayIndex = null
    let longestArray = 0

    Object.values(contentData).forEach((content, index) => {
      if (content?.length > longestArray) {
        longestArray = content.length
        longestArrayIndex = index
      }
    })
    return Object.keys(contentData)[longestArrayIndex]
  }

  return (
    <>
      {options?.[getOptionToLoopOver()]?.[locationIndex].map((box, index) => {
        return (
          <Link
            key={nanoid()}
            variant={`${variantName}.box`}
            className="box"
            sx={{
              pointerEvents: ctaLinks ? 'visible' : 'none'
            }}
            href={ctaLinks ? generateLink(ctaLinks?.[locationIndex]?.[index], isMultiLocationSite, city) : ''}
            target={`${ctaLinks && checkIfExternalLink(ctaLinks[locationIndex][index]) ? '_blank' : ''}`}
            rel={`${ctaLinks && checkIfExternalLink(ctaLinks[locationIndex][index]) ? 'noreferrer' : ''}`}
          >
            {images && (
              <ImageSelector
                className="image"
                variant={`${variantName}.image`}
                image={images[locationIndex][index]} // image from config
                poweredImages={poweredImages} // powered iamges object
                locationIndex={locationIndex}
                imageWidth={600}
              />
            )}
            {dates && (
              <Text variant={`${variantName}.date`} className="date" as="p">
                {dates[locationIndex][index]}
              </Text>
            )}
            {titles && (
              <Heading variant={`${variantName}.title`} className="title" as="h3">
                {titles[locationIndex][index]}
              </Heading>
            )}
            {subtitles && (
              <Heading variant={`${variantName}.subtitle`} className="subtitle" as="h4">
                {subtitles[locationIndex][index]}
              </Heading>
            )}
            {texts && (
              <Text variant={`${variantName}.text`} className="text" as="p">
                {texts[locationIndex][index]}
              </Text>
            )}
          </Link>
        )
      })}
    </>
  )
}
